/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/


import { createApp } from 'vue'







import '@quasar/extras/material-icons/material-icons.css'

import '@quasar/extras/material-symbols-rounded/material-symbols-rounded.css'



import '@quasar/extras/animate/slideInDown.css'

import '@quasar/extras/animate/rubberBand.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'


// We add Quasar addons, if they were requested
import 'quasar/src/css/flex-addon.sass'



import 'src/css/app.scss'

import '@bildvitta/quasar-app-extension-responsive/src/css/spaces.scss'

import '@bildvitta/quasar-app-extension-responsive/src/css/typography.scss'

import '@bildvitta/quasar-app-extension-responsive/src/css/positions.scss'

import '@bildvitta/quasar-app-extension-responsive/src/css/sizing.scss'

import '@bildvitta/quasar-app-extension-asteroid/src/index.scss'


import createQuasarApp from './app.js'
import quasarUserOptions from './quasar-user-options.js'







const publicPath = `/`


async function start ({
  app,
  router
  , store
}, bootFiles) {
  

  
  let hasRedirected = false
  const getRedirectUrl = url => {
    try { return router.resolve(url).href }
    catch (err) {}

    return Object(url) === url
      ? null
      : url
  }
  const redirect = url => {
    hasRedirected = true

    if (typeof url === 'string' && /^https?:\/\//.test(url)) {
      window.location.href = url
      return
    }

    const href = getRedirectUrl(url)

    // continue if we didn't fail to resolve the url
    if (href !== null) {
      window.location.href = href
      
    }
  }

  const urlPath = window.location.href.replace(window.location.origin, '')

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    try {
      await bootFiles[i]({
        app,
        router,
        store,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        redirect(err.url)
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  app.use(router)
  

  

    

    
      app.mount('#q-app')
    

    

  

}

createQuasarApp(createApp, quasarUserOptions)

  .then(app => {
    // eventually remove this when Cordova/Capacitor/Electron support becomes old
    const [ method, mapFn ] = Promise.allSettled !== void 0
      ? [
        'allSettled',
        bootFiles => bootFiles.map(result => {
          if (result.status === 'rejected') {
            console.error('[Quasar] boot error:', result.reason)
            return
          }
          return result.value.default
        })
      ]
      : [
        'all',
        bootFiles => bootFiles.map(entry => entry.default)
      ]

    return Promise[ method ]([
      
      import(/* webpackMode: "eager" */ 'boot/store-adapter'),
      
      import(/* webpackMode: "eager" */ 'boot/axios'),
      
      import(/* webpackMode: "eager" */ 'boot/chatwoot'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-hub/src/boot/auth-pinia.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-analytics/src/boot/gtm-v3.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/api.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/debug.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/error-pages.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/font-face.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/register.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/loading.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/query-cache.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/store-adapter'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/before-each.js'),
      
      import(/* webpackMode: "eager" */ '@bildvitta/quasar-app-extension-asteroid/src/boot/notifications')
      
    ]).then(bootFiles => {
      const boot = mapFn(bootFiles).filter(entry => typeof entry === 'function')
      start(app, boot)
    })
  })

